import { RouteObject } from "react-router-dom";
import SidebarLayout from "./layouts/SidebarLayout";
import BaseLayout from "./layouts/BaseLayout";
import { useContext } from "react";
import { SidebarContext } from "./contexts/SidebarContext";
import Home from "./pages/dashboard/components/home/home";
import ForgotPassword from "./pages/password/forgot-password/components";
import ResetPassword from "./pages/password/reset-password/components";
import Login from "./pages/authentication/components";
import ResetUserPassword from "./pages/user-management/users/components/resetUserPassword";
import ResetSuccess from "./pages/password/reset-success";

let appRoutes: RouteObject[];

const Router = () => {
  const { routes } = useContext(SidebarContext);

  appRoutes = [
    {
      path: "",
      element: <BaseLayout />,
      children: [
        {
          path: "",
          element: <Home />,
        },
        {
          path: "/login",
          element: <Login />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPassword />,
        },
        {
          path: "/reset-password",
          element: <ResetPassword />,
        },
        {
          path: "/reset-success",
          element: <ResetSuccess />,
        },
      ],
    },
    {
      element: <SidebarLayout />,
      children: routes?.concat([
        {
          path: "/reset-user-password/:id",
          element: <ResetUserPassword />,
        },
        {
          path: "*",
          element: <Home />,
        },
      ]),
    },
  ];

  return appRoutes;
};

export default Router;
